import { render, staticRenderFns } from "./ModelTagTypeSelect.vue?vue&type=template&id=a12b35b0&scoped=true"
import script from "./ModelTagTypeSelect.vue?vue&type=script&lang=ts"
export * from "./ModelTagTypeSelect.vue?vue&type=script&lang=ts"
import style0 from "./ModelTagTypeSelect.vue?vue&type=style&index=0&id=a12b35b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12b35b0",
  null
  
)

export default component.exports